export default __webpack_public_path__ + "static/media/icone edição.f420432c.svg";